import type { Building, DevelopmentPlan, Energy, Project } from './types';
import { ratioKey } from './data';

// Formule illustrative isolée : le métier doit confirmer les paramètres et la correction DJU.
export function calculatedConsumption(b: Building, project: Project, energy: Energy): number {
  const ratio = project.ratios[energy][ratioKey(b.usage, b.period)];
  const coefficient = energy === 'heat' ? project.stationDju / project.dju : 1;
  return b.surface * ratio / 1000 * coefficient;
}
export const effectiveConsumption = (b: Building, p: Project, e: Energy) =>
  b.corrections[e] ?? calculatedConsumption(b, p, e);
export const totalDemand = (plan: DevelopmentPlan, buildings: Building[], p: Project) =>
  buildings.filter(b => b.id in plan.subscribers).reduce((sum, b) => sum + effectiveConsumption(b, p, plan.energy), 0);
export const fmt = (n: number) => n.toLocaleString('fr-FR', { maximumFractionDigits: 1 });
export function lengthKm(plan: Pick<DevelopmentPlan, 'pipes'>) {
  return plan.pipes.reduce((sum, pipe) => sum + pipe.coordinates.slice(1).reduce((distance, b, i) => {
    const a = pipe.coordinates[i];
    return distance + 111.32 * Math.hypot((b[0] - a[0]) * Math.cos(a[1] * Math.PI / 180), b[1] - a[1]);
  }, 0), 0);
}
export const planStatus = (p: DevelopmentPlan) => p.stale ? 'À recalculer' :
  !p.snapshot && !p.pipes.length ? 'Brouillon' :
    p.pipes.some(pipe => !pipe.month) || Object.values(p.subscribers).some(month => !month) ? 'Phasage à compléter' : 'Complet';
